const REGISTRATION_GRACE_HOURS = 12;

export function isWithinRegistrationGrace(user) {
  if (!user || !user.created_at) {
    return false;
  }

  const createdAt = new Date(user.created_at);
  if (Number.isNaN(createdAt.getTime())) {
    return false;
  }

  const graceEndsAt = new Date(
    createdAt.getTime() + REGISTRATION_GRACE_HOURS * 60 * 60 * 1000,
  );

  return new Date() < graceEndsAt;
}

export function canOpenDetail(hasAccess, user) {
  return Boolean(hasAccess) || isWithinRegistrationGrace(user);
}
